module.exports = __webpack_public_path__ + "static/media/robobg.dfe47938.jpg";